mutation CreateShelly {
    shellyCreate {
        didCreate
    }
}
